// Static manifest of the "Getting Started" tutorial videos shown in the Help Center.
// Assets live in S3 under `${HELP_ASSETS_URL}/help/<file>.mp4` (+ matching .jpg poster).
// Captions are burned into the videos; set `hasCaptions: true` once a .vtt track is
// uploaded alongside a video to also offer selectable captions.

export interface HelpVideo {
  id: string;
  order: number;
  title: string;
  description: string;
  durationSec: number;
  prereq?: string;        // optional hint, e.g. "Needs a Silver plan or higher"
  file: string;           // basename in the bucket (no extension)
  hasCaptions?: boolean;  // render a <track> if a .vtt exists
}

const BASE = `${process.env.HELP_ASSETS_URL || ''}/help`;

export const videoUrl = (v: HelpVideo): string => `${BASE}/${v.file}.mp4`;
export const posterUrl = (v: HelpVideo): string => `${BASE}/${v.file}.jpg`;
export const captionsUrl = (v: HelpVideo): string => `${BASE}/${v.file}.vtt`;

export const formatDuration = (s: number): string =>
  `${Math.floor(s / 60)}:${String(Math.round(s % 60)).padStart(2, '0')}`;

// Note: "Create your account" (video1-account) is intentionally omitted — the Help
// Center is behind login, so account creation isn't relevant here.
export const HELP_VIDEOS: HelpVideo[] = [
  {
    id: 'plan', order: 1, title: 'Choose a plan', durationSec: 23,
    file: 'video2-plan',
    description: 'Compare Bronze, Silver, and Gold, then subscribe.',
  },
  {
    id: 'org', order: 2, title: 'Register your organization', durationSec: 28,
    file: 'video3-organization',
    description: 'Set up the business profile your ads and campaigns belong to.',
  },
  {
    id: 'ai-ad', order: 3, title: 'Create an AI ad', durationSec: 48,
    file: 'video4-ai-ad',
    description: 'Describe what you want and let AI generate the creative.',
    prereq: 'Needs a Silver plan or higher',
  },
  {
    id: 'upload', order: 4, title: 'Upload an image for an ad', durationSec: 33,
    file: 'video5-upload-ad',
    description: 'Bring your own image or video and turn it into an ad.',
  },
  {
    id: 'geofence', order: 5, title: 'Create a Geo Fence campaign', durationSec: 43,
    file: 'video6-geofence',
    description: 'Target everyone within a radius around a location.',
  },
  {
    id: 'route', order: 6, title: 'Create a Draw-Your-Route campaign', durationSec: 43,
    file: 'video7-drawroute',
    description: 'Draw a custom route on the map for your ad to travel.',
  },
];
